const initialState = {
  id: "infotext-notif",
  title: "",
  isOpen: false,
  setIsOpen: () => {},
  content: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "NOTIF_UPDATE":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
